import { createContextHook } from '@/utils';
import { ItemCardContext } from './ItemCardContext';

export const useItemCardContext = createContextHook(ItemCardContext);
